import { render, staticRenderFns } from "./PackageClaimList.vue?vue&type=template&id=9d08f918&"
import script from "./PackageClaimList.vue?vue&type=script&lang=js&"
export * from "./PackageClaimList.vue?vue&type=script&lang=js&"
import style0 from "./PackageClaimList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackageClaimList.vue"
export default component.exports